module.exports = __webpack_public_path__ + "img/br-cd.8ee5e8dc.svg";